import src from "IMAGE";
export default { src, width: 236, height: 64, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAMklEQVR42g3DsQ2AIAAEwN/KHSxNNJZqZ4CKHUjYmisuSSadyk/j42KQnZvCw8vJxrEA0nIGKVrBk3QAAAAASUVORK5CYII="};
